import { render } from "./slide17.vue?vue&type=template&id=142480d9&scoped=true"
import script from "./slide17.vue?vue&type=script&lang=js"
export * from "./slide17.vue?vue&type=script&lang=js"

import "./slide17.vue?vue&type=style&index=0&id=142480d9&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-142480d9"]])

export default __exports__